import { render, staticRenderFns } from "./NewEntityNote.vue?vue&type=template&id=725f21f5&"
import script from "./NewEntityNote.vue?vue&type=script&lang=js&"
export * from "./NewEntityNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports